angular.module('ikeweb.user').controller('PurchasePremiumController', ['$scope', 'billingService', 'creditCardService', 'events', '$rootScope', 'promiseFactory', 'subscriptionActionService', 'functional',
    function($scope, billingService, creditCardService, events, $rootScope, promiseFactory, subscriptionActionService, f) {

        $scope.displayEvent = events.BILLING.PURCHASE.DISPLAY_MODAL;
        $scope.dismissEvent = events.BILLING.PURCHASE.DISMISS_MODAL;
        $scope.notifications = {};
        $scope.card = {};
        $scope.planNotSelected = false;
        $scope.selectedTrial = false;

        $scope.subscriptionWillEnd = function() {
            var subscription = $scope.subscription;
            return (subscription != null && subscription.cancel_at_period_end);
        };

        function canSelectPlan(plan) {
            if ($scope.isOnTrial || !plan || !$scope.subscription) {
                return true;
            }
            if ($scope.shouldRenew) {
                return subscriptionActionService.canRenewPlanTo($scope.subscription.plan, plan);
            }
            return subscriptionActionService.canChangePlanTo($scope.subscription.plan, plan);
        }

        function initSelectedPlan(plan) {
            if ($scope.isOnTrial || !plan) {
                return undefined;
            }
            if ($scope.shouldRenew) {
                return plan;
            }
            return $scope.selectablePlans.filter(f.not(f.propertyEquals('interval', plan.interval)))[0];
        }

        $scope.selectPlan = function(plan) {
            if (!canSelectPlan(plan)) {
                $scope.cannotSelectMonthlyError = true;
                return;
            }
            $scope.selectedPlan = plan;
            $scope.planNotSelected = false;
            $scope.cannotSelectMonthlyError = false;
        };

        function loadCreditCard() {
            return creditCardService.loadCard({
                cardHolderName: $scope.card.cardHolderName,
                cardNumber: $scope.card.cardNumber,
                cvv: $scope.card.cvv,
                expiryMonth: $scope.card.expiryMonth,
                expiryYear: $scope.card.expiryYear,
                zip: $scope.card.zip
            });
        }

        function subscribe(token) {
            var subscribePromise;
            if ($scope.selectedTrial) {
                subscribePromise = billingService.subscribeTrial($scope.selectedPlan.id, token);
            } else {
                subscribePromise = billingService.subscribe($scope.selectedPlan.id, token);
            }
            return subscribePromise.then(function(subscription) {
                $rootScope.$broadcast(events.SUBSCRIPTION.CREATED, subscription);
                return subscription;
            });
        }

        $scope.closePurchasePremiumModal = function() {
            $rootScope.$broadcast($scope.dismissEvent);
        };

        $scope.closeThankYouModal = function() {
            $rootScope.$broadcast($scope.dismissThankYouEvent);
        };

        $scope.purchase = function() {
            if (!$scope.selectedPlan) {
                $scope.planNotSelected = true;
                return;
            }

            $scope.purchasing = true;

            ($scope.currentCard ? promiseFactory.resolvedPromise() : loadCreditCard())
            .then(subscribe)
                .then(function() {
                    $scope.closePurchasePremiumModal();
                    $scope.purchasing = false;
                }, function() {
                    $scope.purchasing = false;
                });

        };

        function refresh(trial) {
            $scope.cannotSelectMonthlyError = false;
            $scope.loading = true;
            $scope.selectedTrial = trial ? trial : false;
            promiseFactory.all([
                billingService.getCurrentCreditCard(),
                billingService.getActiveSubscription(),
                billingService.getAvailablePlans(),
                billingService.eligibleForTrial(),
                subscriptionActionService.shouldRenew(),
                subscriptionActionService.isOnTrial()

            ]).then(function(values) {
                $scope.loading = false;
                $scope.currentCard = values.shift();
                $scope.subscription = values.shift();
                $scope.selectablePlans = values.shift();
                $scope.canTrial = values.shift();
                $scope.shouldRenew = values.shift();
                $scope.isOnTrial = values.shift();
                $scope.selectedPlan = initSelectedPlan($scope.subscription ? $scope.subscription.plan : undefined);
                if ($scope.selectedTrial) {
                    $scope.selectablePlans = $scope.selectablePlans.filter(function(obj) {
                        if (obj.interval === 'month') {
                            return true;
                        }
                        return false;

                    });
                    $scope.selectedPlan = $scope.selectablePlans[0]; //should contain just the monthly plan
                }
                if (trial != null) {
                    // display modal when refresh is called from a UI event
                    $scope.$broadcast(events.BILLING.PURCHASE.DISPLAY_MODAL);
                }
            });
        }

        refresh();
        $scope.$on(events.BILLING.PURCHASE_PREMIUM.DISPLAY, refresh.bind(null, false));
        $scope.$on(events.BILLING.PURCHASE_TRIAL.DISPLAY, refresh.bind(null, true));
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/user/billing/purchase.premium.controller.js
// module id = 503
// module chunks = 0